<template>
    <div class="container">
        <div style="text-align:left">
        <div style="width:100%;text-align:center" v-on:click="rout('/index')">
            <img src="@/assets/logo.png" width="30%"  />
            
        </div>
       
        <p class="control has-icons-left has-icons-right">
          <input type="text"
                 placeholder="Votre nom !!!"
                 class="input is-rounded is-medium"
                 v-model="displayName"
          />
          <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
          </span>
           <div v-show="error.nom" class="danger">
              Un nom doit être saisi 
            </div>
           <br/> 
        </p>
        <p class="control has-icons-left has-icons-right">
                <input type="email" 
                :class="error.email ? 'input is-rounded is-danger is-medium' : 'input is-rounded is-medium'" 
                v-model="email" placeholder="Votre email"
                 @change="verifEmail"/>
                 <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
                <div v-show="error.email" class="danger">
                    Le mail est obligatoire et doit respecter le format xxxx@xxxx.xx
                </div>
                <div v-show="error.exist" class="danger">
                  Cet email a déjà été utilisé ... </br>
                  Vous avez peut être oublier votre mot de passe </br>
                </div>
                </p>
                <br/>
        
         <p class="control has-icons-left has-icons-right">
                   <input type="password" 
                   :class="error.pwd ? 'input is-rounded is-danger  is-medium' : 'input is-rounded  is-medium'"  
                   v-model="password" placeholder="Votre mot de passe"
                   @change="verifPwd"/>
                   <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                   </span>
                   <div v-show="error.pwd" class="danger">
                      Les mots de passe sécurisés comportent au moins six caractères 
                      et une combinaison de chiffres et de lettres
                   </div>
                </p>
                <br/>
                
                <div :class="infoSendMail ? 'modal is-active':'modal'">
                  <div class="modal-background"></div>
                  <div class="modal-card">
                  <section class="modal-card-body">
                    Vous avez bien été enregistré <br/>
                    Un mail a été envoyé avec un code pour valider l'email...<br/>
                  </section>
                  <footer class="modal-card-foot">
                    <s-button label="J'ai compris" icon="thumbs-up" @onclick="connect" theme="is-success"/>
                  </footer>
                  </div>
                </div>
       
                <p class="control has-icons-left has-icons-right">
                   <input type="password" class="input is-rounded  is-medium" 
                   v-model="confirmPassword" placeholder="Confirmez le mot de passe"
                    @change="verifConfirm"/>
                   <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                  <span v-show="error.confirmPwd" class="danger">
                   Les mots de passe ne correspondent pas
                </span>
                </p>
             
        
        </div>
        <div style="float:right">
        <br/><br/>
       
        </div>
        <div class="buttons">
          
          <div >
            <s-button label="Enregistrer" icon="save" :theme="themeSave" @onclick="save()"
            />
          </div>
        </div>
    </div>
</template>
<style scoped>
  .container div {
    margin-left: 10px;
    margin-right: 10px;
  }
  .buttons {
    margin-top: 30px;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    display: inline-block;
  }
  .danger {
    font-style: italic;
    font-size: smaller;
    color: red;
  }
  
</style>
<script>
import firebase from "firebase/app";
import user_fct         from "@/firebase/user"

import keys from '@/firebase/keys_firebase'
export default {
   
    data:function() {
    return {
      email: "",
      password: "",
      confirmPassword : "",
      
      displayName: "",
      error: {
        nom: false,
        pwd: false,
        email: false,
        exist: false,
        confirmPwd: false
      },
      infoSendMail: false,
      themeSave: "is-success is-large"
    }
  },
  methods: {
     
       verifyCaptcha(fct) {
          this.$sendRecaptcha( this.$recaptchaLoaded(), this.$recaptcha('login'), result=>{
              if (result.data.data.success) {
                  fct();
              }
          })
      },
      
      connect() {
       
        this.$emit("connect");    
      },
      verifName() {
         this.error.nom = this.displayName == "";
      },
      verifEmail() {
         this.error.email = this.email == "";
         if (!this.error.email) {
            var reEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            this.error.email = !this.email.match(reEmail);
         }
      },
      verifPwd() {
         this.error.pwd = !(this.password.match( /[0-9]/g) && 
                    (this.password.match( /[A-Z]/g) ||
                    this.password.match(/[a-z]/g)) && 
                    this.password.length >= 6)
      },
       verifConfirm() {
         this.error.confirmPwd = this.confirmPassword != this.password;
      },
      rout(nav) {
       /* const recaptcha = this.$recaptchaInstance
        if (recaptcha)
          recaptcha.hideBadge();
        this.$router.push(nav).catch(error=>{})*/
      },
      save() {
        this.verifyCaptcha(()=>{
          this.error.pwd = this.password == "";
          this.error.email = this.email == "";
          

          if (!this.error.email) {
            var reEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            this.error.email = !this.email.match(reEmail);
          }
          
          if (!this.error.pwd) {
             this.error.pwd = !(this.password.match( /[0-9]/g) && 
                    (this.password.match( /[A-Z]/g) ||
                    this.password.match(/[a-z]/g)) && 
                    this.password.length >= 6)
          }
        this.verifName();
        
        this.error.confirmPwd = this.confirmPassword != this.password;
        
        if (!this.error.nom && !this.error.pwd && !this.error.email && !this.error.confirmPwd) {
            // Execute reCAPTCHA with action "login".
          
           // this.$sendRecaptcha( this.$recaptchaLoaded(), this.$recaptcha('register'), result=>{
             
            //  if (result.data.data.success) {
                this.themeSave = "is-loading";
                firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
                .then(result=> {
                        
                        result.user.updateProfile({
                          displayName: this.displayName
                        })
                        
                        var user = firebase.auth().currentUser;
                        
                            this.error.exist = false;
                            this.themeSave = "is-loading"
                            this.$store.dispatch("init", ()=>{
                                  this.themeSave = "is-success is-large";
                                  this.infoSendMail = true;
                                   const currentUser = firebase.auth().currentUser;
                                   user_fct.object.sendCode(currentUser);  
                            })
                           
                      
                })
                .catch(error=> {
                      if (error.code =="auth/email-already-in-use") {
                        this.themeSave = "is-success is-large";
                        this.error.exist = true;
                      }
                      if (error.code =="auth/invalid-email") {
                        this.error.email=true;
                         this.themeSave = "is-success is-large";
                      }
                     
                      });
              }
              else {
                console.log("Probleme : captcha non valide !")
                
              }
         // }
                  
        }) // en if
      } // save
    
  }// methods
  ,
  mounted() {
   /* const recaptcha = this.$recaptchaInstance
     if (recaptcha)
      recaptcha.showBadge();*/
  }
}
</script>